import { render } from "./SpHeader.vue?vue&type=template&id=7a38bc70"
import script from "./SpHeader.vue?vue&type=script&lang=js"
export * from "./SpHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__